var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-o2o-enroll-audit" },
    [
      _vm.isProjectset === false
        ? [
            _c("div", { staticClass: "standard-size-16 color-gray-10" }, [
              _c(
                "div",
                { staticClass: "mb32 font-bolder" },
                [
                  _vm._v(
                    "\n       " +
                      _vm._s(
                        _vm.$t("pc_biz_enroll_lbl_project" /* 报名项目 */)
                      ) +
                      "\n       "
                  ),
                  _c(
                    "yxtf-row",
                    {
                      staticClass: "mv24 font-normal font-size-14",
                      attrs: { type: "flex" },
                    },
                    [
                      _c(
                        "yxtf-col",
                        {
                          staticClass: "nowrap mh2 felx-center",
                          attrs: { span: 24 },
                        },
                        [
                          _c("span", { staticClass: "color-gray-7" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_biz_enroll_lbl_projectname" /* 项目名称 */
                                )
                              ) +
                                _vm._s(
                                  _vm.$t("pc_biz_enroll_lbl_colon" /* ： */)
                                )
                            ),
                          ]),
                          _c(
                            "yxtf-tooltip",
                            {
                              attrs: {
                                "open-filter": true,
                                content: _vm.projectInfo.name,
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "yxtbiz-o2o-enroll-audit_ellipsis",
                                },
                                [_vm._v(_vm._s(_vm.projectInfo.name || "--"))]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxtf-row",
                    {
                      staticClass: "mv24 font-normal font-size-14",
                      attrs: { type: "flex" },
                    },
                    [
                      _c(
                        "yxtf-col",
                        {
                          staticClass: "nowrap mh2 felx-center",
                          attrs: { span: 24 },
                        },
                        [
                          _c("span", { staticClass: "color-gray-7" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_biz_enroll_lbl_projecttime" /* 项目时间 */
                                )
                              ) +
                                _vm._s(
                                  _vm.$t("pc_biz_enroll_lbl_colon" /* ： */)
                                )
                            ),
                          ]),
                          _c(
                            "yxtf-tooltip",
                            {
                              attrs: {
                                "open-filter": true,
                                placement: "top",
                                content: _vm.projectInfo.time,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "yxtbiz-o2o-enroll-audit_ellipsis",
                                },
                                [_vm._v(_vm._s(_vm.projectInfo.time || "--"))]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-row",
                    {
                      staticClass: "yxtbiz-project-audit__row",
                      attrs: { gutter: 32 },
                    },
                    [
                      _c(
                        "yxt-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "yxt-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.goProjectDetail },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pc_biz_view_project_detail" /* 查看项目详情 */
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm.isProjectset === true
        ? _c("O2oEnrollProjectsetAudit", { attrs: { id: _vm.id } })
        : _vm._e(),
      _c("xxbiz-signup", {
        attrs: { mod: "info", id: _vm.auditId },
        on: { callback: _vm.callback },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }